module.exports = "/images/badge_status_reserved.png?dcb2ca679f61ae0fc6f08c9a326125b4";